import { Button, Divider } from "antd";
import { SizeType } from "antd-v5/lib/config-provider/SizeContext";
import { CalendarIcon } from "components/Icons";
import _, { noop } from "lodash";
import React, { useCallback, useRef, useState } from "react";
import { parseDateToDisplay } from "utils/dateUtils";

import ACDateRangeColumnFilter from "ac-components/ACDateRangeColumnFilter";
import { Values } from "ac-components/ACDateRangeFilter";
import ACTrigger from "ac-components/ACTrigger";

type Props = {
  value: React.Key[];
  onChange: (value: Values) => void;
  className?: string;
  size?: SizeType;
  style?: React.CSSProperties;
};

export default function ACDurationPicker({
  value,
  onChange,
  className = "",
  size = "middle",
  style = {},
}: Props) {
  const [popupVisible, setPopupVisible] = useState<boolean>(false);
  const selectedKeys = useRef<React.Key[]>(value);

  const _onApply = useCallback(() => {
    setPopupVisible(false);
    onChange(selectedKeys.current);
  }, [onChange, selectedKeys]);

  const setSelectedKeys = useCallback((values) => {
    selectedKeys.current = values;
  }, []);

  return (
    <ACTrigger
      trigger={["click"]}
      placement="bottomRight"
      onPopupVisibleChange={setPopupVisible}
      popupVisible={popupVisible}
      popup={
        <div style={{ border: "1px solid rgba(236, 241, 250, 1)" }}>
          <ACDateRangeColumnFilter
            prefixCls=""
            confirm={_onApply}
            visible={popupVisible}
            setSelectedKeys={setSelectedKeys}
            selectedKeys={value}
            close={noop}
          />
        </div>
      }
    >
      <Button className={className} size={size} style={style} block>
        <div className="d-flex align-items-center justify-content-between">
          <span>{formatDatesFromRelativePicker(value)}</span>
          <span>
            <Divider type="vertical" />
            <CalendarIcon />
          </span>
        </div>
      </Button>
    </ACTrigger>
  );
}

export const formatDatesFromRelativePicker = (values: Values) => {
  return values && !_.isEmpty(values)
    ? `${parseDateToDisplay(values[0])} -> ${parseDateToDisplay(values[1])}`
    : "All data";
};
